import BaseEnum from './base-enum';

export default BaseEnum.create({
  values: [
    { value: 1, label: 'Duo' },
    { value: 2, label: 'Suite' },
    { value: 3, label: 'Pupil Billing' },
    { value: 4, label: 'Premier' },
    { value: 5, label: 'Multi Jurisdictional' },
    { value: 6, label: 'Starter Pack' },
    { value: 7, label: 'Pages Power Up' },
    { value: 8, label: 'Goals Power Up' },
    { value: 9, label: 'Reporting Power Up' },
    { value: 10, label: 'Milestones Power Up' },
    { value: 11, label: 'Communications Kit' },
    { value: 12, label: 'Administration Kit' },
  ],
});
